/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod6_BodyInputs */

const es_landing_mod6_body = /** @type {(inputs: Landing_Mod6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La misma tarifa plana del 15%, la más barata de su categoría.`)
};

const gl_landing_mod6_body = /** @type {(inputs: Landing_Mod6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mesma tarifa plana do 15%, a máis barata da súa categoría.`)
};

const en_landing_mod6_body = /** @type {(inputs: Landing_Mod6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same flat 15% rate — the cheapest in its category.`)
};

/**
* | output |
* | --- |
* | "The same flat 15% rate — the cheapest in its category." |
*
* @param {Landing_Mod6_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod6_body = /** @type {((inputs?: Landing_Mod6_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod6_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod6_body(inputs)
	if (locale === "en") return en_landing_mod6_body(inputs)
	return es_landing_mod6_body(inputs)
});